// extracted by mini-css-extract-plugin
export default {"Bprivacy":"airPrivacy_Bprivacy__Gnn+t","pt18":"airPrivacy_pt18__hnaW3","pt12":"airPrivacy_pt12__5VnnZ","pt135":"airPrivacy_pt135__oyLpY"};